import { render } from "./PhotoGalleryComponent.vue?vue&type=template&id=672987fe&scoped=true"
import script from "./PhotoGalleryComponent.vue?vue&type=script&lang=js"
export * from "./PhotoGalleryComponent.vue?vue&type=script&lang=js"

import "./PhotoGalleryComponent.vue?vue&type=style&index=0&id=672987fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672987fe"]])

export default __exports__